// extracted by mini-css-extract-plugin
module.exports = {"skip-link-container":"SkipContent_skip-link-container__2QlvC","skip-link":"SkipContent_skip-link__17wgx"};